import {shareOrCopy} from "./share";

export default class SpeakerShare {
    constructor($el) {
        this.$el = $el;
        this.statusTimeout = null;

        this.bindShare();
    }

    bindShare() {
        this.$el.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            const result = await shareOrCopy(this.getShareData());

            if (result === 'copied') {
                this.showStatus('Link gekopieerd');
            }
        });
    }

    getShareData() {
        return {
            title: this.$el.dataset.shareTitle || document.title,
            text: this.$el.dataset.shareText || document.title,
            url: this.getShareUrl(),
        };
    }

    getShareUrl() {
        return new URL(
            this.$el.dataset.shareUrl || this.$el.getAttribute('href') || window.location.href,
            window.location.origin
        ).toString();
    }

    showStatus(message) {
        const $header = this.$el.closest('.speaker-detail__header') || this.$el.parentNode;
        let $status = $header.querySelector('[data-speaker-share-status]');

        if (! $status) {
            $status = document.createElement('p');
            $status.className = 'speaker-detail__share-status';
            $status.setAttribute('data-speaker-share-status', '');
            $status.setAttribute('aria-live', 'polite');
            $header.appendChild($status);
        }

        $status.textContent = message;
        clearTimeout(this.statusTimeout);
        this.statusTimeout = setTimeout(() => {
            $status.textContent = '';
        }, 2400);
    }
}
